/**
 * Each interval that is supported
 */
export const Interval = Object.freeze({
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const);

/**
 * Each interval that is supported
 */
export type Interval = (typeof Interval)[keyof typeof Interval];

export type AggregationPeriod = {
    interval: Interval;
    fromDate: Date;
    toDate: Date;
};
